import { memo } from 'react';
import { OpenLegisVM } from 'mutation/view-models/registration-citizenship';
import { Grid, useEventCallback } from '@mui/material';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import ArticleList from '../shared/article-list';
import { ItemVM } from 'shell/view-models/item';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';

interface OpenLegisProps {
  values?: OpenLegisVM;
  onChange: (key: keyof OpenLegisVM, value: OpenLegisVM[keyof OpenLegisVM]) => void;
  idReason: string;
  disabled?: boolean;
}

const OpenLegisComponent = ({
  onChange,
  values,
  idReason,
  disabled,
}: OpenLegisProps): React.ReactElement => {
  const onChangeArticleList = useEventCallback((value: ItemVM<MotArtCitizenship> | null) => {
    onChange('article', value);
  });

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Citt. Italiana da"
          aria-label="Citt. Italiana da"
          value={values?.dateForm || null}
          onChange={(date) => {
            onChange('dateForm', date);
          }}
          renderInput={(params) => (
            <PmiTextField id="dateForm" {...params} fullWidth helperText="" disabled={disabled} />
          )}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <ArticleList
          value={values?.article?.id?.toString() || ''}
          onChange={onChangeArticleList}
          idReason={idReason}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

OpenLegisComponent.displayName = 'Form Accordion Registration Citizenship - Open Legis component';

const OpenLegis = memo(OpenLegisComponent);

export default OpenLegis;
